import { api } from "./axios";

export interface ReferringDoctorResult {
  practice_id: number;
  practice_name: string;
  doctor_id: number | null;
  doctor_name: string | null;
  label: string;
}

interface SearchResponse {
  data: ReferringDoctorResult[];
}

export const searchReferringDoctors = async (
  query: string,
): Promise<ReferringDoctorResult[]> => {
  if (query.length < 1) return [];

  const { data } = await api.get<SearchResponse>("referring-doctors/search", {
    params: { q: query },
  });

  return data.data;
};
